import { getGlobal as v } from "./index21.js";
var r, _, l = v(), t = (r = (_ = l).__SEGMENT_INSPECTOR__) !== null && r !== void 0 ? r : _.__SEGMENT_INSPECTOR__ = {}, c = function(o) {
  var a;
  return (a = t.attach) === null || a === void 0 ? void 0 : a.call(t, o);
};
export {
  c as attachInspector
};
//# sourceMappingURL=index41.js.map
